var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 57.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 169") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.25,15.24a51.13,51.13,0,0,0-72.84,0L0,28.81,13.75,42.72a51.14,51.14,0,0,0,72.84,0L100,29.15ZM84.2,40.3a47.78,47.78,0,0,1-68.06,0L4.78,28.81l11-11.16a47.78,47.78,0,0,1,68.06,0L95.22,29.15Zm-35.93-25a11.91,11.91,0,0,0-11.82,12,1.69,1.69,0,1,0,3.38,0,8.51,8.51,0,0,1,8.45-8.55,1.71,1.71,0,0,0,0-3.42ZM50,6.71a22.22,22.22,0,1,0,22,22.22A22.12,22.12,0,0,0,50,6.71Zm0,41a18.8,18.8,0,1,1,18.58-18.8A18.71,18.71,0,0,1,50,47.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.dbb55a58f4c2dd6022d0cbc3ddcbb14c.svg";
export { ForwardRef as ReactComponent };